// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Bzv1","container":"styles_container__1jsKx","title":"styles_title__2xaIh","wrapper":"styles_wrapper__1Jh5q","answer":"styles_answer__1DbNn"};